import React from "react";

export default function SolutionBlock({id, overline, title, blurb, bullets, image, reverse,
                                          ctaHref = "/get-started", ctaLabel = "Get started"}) {
    return (
        <section id={id} className={`solution-block ${reverse ? "sb-reverse" : ""}`}>
            <div className="container sb-grid">
                <div className="sb-copy">
                    <span className="sb-overline">{overline}</span>
                    <h2 className="sb-title">{title}</h2>
                    <p className="sb-blurb">{blurb}</p>

                    <ul className="sb-list">
                        {bullets.map((b, i) => (
                            <li key={i}>
                                <span className="sb-tick" aria-hidden="true">✓</span>
                                <span>{b}</span>
                            </li>
                        ))}
                    </ul>

                    <div className="sb-ctas">
                        <a href={ctaHref} className="btn btn-get-started btn-pill">{ctaLabel}</a>
                        <a href="/pricing" className="sb-link">See pricing</a>
                    </div>
                </div>

                <div className="sb-visual">
                    <div className="sb-frame">
                        <img src={image} alt="" />
                    </div>
                </div>
            </div>
        </section>
    );
}
